<ng-container *ngIf="type === 'slider'">
  <div class="flex flex-col p-5">
    <h5 class="mb-4 text-center">{{ title }}</h5>
    <div class="flex items-center justify-center w-full">
      <ark-slider
        [points]="points"
        (pointSelected)="pointSelect($event)"
        [current]="weightId"
        class="w-full"
      ></ark-slider>
    </div>
    <div class="flex items-center justify-center w-full">
      <ark-button class="w-full" size="small" (click)="submit()"
        >Submit</ark-button
      >
    </div>
  </div>
</ng-container>

<ng-container *ngIf="type === 'button'">
  <div class="flex flex-col p-5">
    <h5 class="mb-4 text-center">{{ title }}</h5>
    <div class="flex items-center justify-center">
      <ng-container *ngFor="let weight of weights">
        <div
          class="ml-1 py-1 px-2 flex items-center border border-solid rounded-full"
          [class.border-gray-500]="weight.id === 1"
          [class.border-orange-500]="weight.id === 2"
          [class.border-red-500]="weight.id === 3"
          [class.bg-gray-100]="weightId === weight.id && weightId === 1"
          [class.bg-orange-100]="weightId === weight.id && weightId === 2"
          [class.bg-red-100]="weightId === weight.id && weightId === 3"
          (click)="submit(weight.id)"
        >
          <span
            class="text-sm"
            [class.text-gray-500]="weight.id === 1"
            [class.text-orange-500]="weight.id === 2"
            [class.text-red-500]="weight.id === 3"
            >{{ weight.label }}</span
          >
        </div></ng-container
      >
    </div>
  </div>
</ng-container>
